/* @flow */
import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import Select from "react-select";

import { Desktop, Mobile, MobileAndTablet, TabletAndUp } from "../Responsive";
import ProButton from "./ProButton";
import AddToHomeScreen from "../InstallApp";
import { ZoneBadge } from "../Zones";
import zones from "../../stores/Zones";
import config from "../../config";

import "./Header.css";
import { Logo, Logout } from "../Icons";
import { onLogoTap, appVersion, isApp } from '../../helpers/nativeApp';

export type OwnProps = {
  isPremium: boolean,
  isAuthenticated: boolean,
  isTrial: boolean,
  gymName: string,
  premiumUntil: number,
  volume: number,
};

export type DispatchProps = {
  login: () => void,
  logout: () => void,
  getPro: () => void,
  deleteAccount: () => void,
  showPricing: () => void,
  onVolumeChange: (volume: number) => void,
  onMute: () => void,
  onLoud: () => void,
};

export type Props = OwnProps & DispatchProps;

const explicitOptions = [
  { value: "clean", label: "No explicits" },
  { value: "soft", label: "Soft explicits" },
  { value: "explicit", label: "Explicits" },
];

class Header extends Component<Props, { isOpen: boolean }> {
  state = {
    isOpen: false,
    dropDownOpen: false,
  };

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.login = this.login.bind(this);
    this.signUp = this.signUp.bind(this);
    this.logout = this.logout.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  login() {
    const { userStore } = this.props;
    userStore.login();
  }

  signUp() {
    const { userStore } = this.props;
    userStore.signUp();
  }

  logout() {
    const { userStore } = this.props;
    userStore.logout();
  }

  toggleDropdown() {
    console.log("toggled DropDown");
    this.setState({ dropDownOpen: !this.state.dropDownOpen });
  }

  componentDidMount() {
    const { userStore } = this.props;
    console.log(userStore.email);
    console.log(userStore.gymName);
  }

  render() {
    const {
      onExplicitFilterChange,
      getPro,
      showPricing,
      deleteAccount,
      userStore,
    } = this.props;

    const {
      isPremium,
      isSubscribed,
      isTrial,
      isAuthenticated,
      explicitFilter,
      gymName,
      premiumUntil,
      franchise,
      email,
      name,
    } = userStore;
    const accountName = gymName || name || "";

    const showGetPro = isAuthenticated;
    return (
      <div>
        <Navbar color="light" light expand="lg" className="gr-navbar">
          <NavbarBrand href="/" className="header__brand" onClick={onLogoTap}>
            <img
              src="/assets/images/logo-light.png"
              alt="GymRadio.com"
              className="header__logo"
            />
          </NavbarBrand>
          {showGetPro && (
            <TabletAndUp>
              <ProButton
                isPremium={isPremium}
                isTrial={isTrial}
                getPro={getPro}
                gymName={gymName}
                franchiseName={
                  franchise && franchise.id !== "gymradio" && franchise.name
                }
                premiumUntil={premiumUntil}
                inApp={isApp()}
              />
            </TabletAndUp>
          )}
          {isAuthenticated && <ZoneBadge />}
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              {isAuthenticated && (
                <MobileAndTablet>
                  <NavItem className="header__section header__account-mobile">
                    {accountName && (
                      <span className="dropdown__account-name">{accountName}</span>
                    )}
                    <span className="dropdown__account-email">{email}</span>
                  </NavItem>
                </MobileAndTablet>
              )}
              {isAuthenticated && (
                <div
                  className="header__section header__filter"
                  style={{ position: "relative", zIndex: "100" }}
                >
                  <MobileAndTablet>
                    <span className="header__filter-label">Explicit filter</span>
                  </MobileAndTablet>
                  <Select
                    value={explicitOptions.find((option) => {
                      return option.value === explicitFilter;
                    })}
                    isSearchable={false}
                    classNamePrefix="selectbox"
                    className="selectbox"
                    onChange={onExplicitFilterChange}
                    options={explicitOptions}
                  />
                </div>
              )}
              {/* volume now lives in the player bar at the bottom */}
              {/* Phone app: nothing is sold in the app (store rules), so no Pricing link */}
              {isAuthenticated && !isSubscribed && !isApp() && (
                <NavItem className="header__section">
                  <NavLink onClick={() => { this.setState({ isOpen: false }); showPricing(); }}>Pricing</NavLink>
                </NavItem>
              )}
              {isAuthenticated && (
                <Desktop>
                  <NavItem className="header__section header__section--logout">
                    <Dropdown
                      isOpen={this.state.dropDownOpen}
                      toggle={this.toggleDropdown}
                    >
                      <DropdownToggle className="dropdown">
                        {email.split("@")[0]}
                        <span className="dropdown__caret-icon">
                        <svg
                          height="16"
                          width="16"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"  fill="currentColor"/>
                        </svg>
                        </span>
                        
                      </DropdownToggle>
                      <DropdownMenu className="dropdown__menu" right>
                        <DropdownItem header className="dropdown__account">
                          {accountName && (
                            <span className="dropdown__account-name">{accountName}</span>
                          )}
                          <span className="dropdown__account-email">{email}</span>
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem tag="div" toggle={false} className="dropdown__item dropdown__item--home">
                          <AddToHomeScreen />
                        </DropdownItem>
                        {zones.enabled && !zones.playOnly && (
                          <DropdownItem className="dropdown__item">
                            <NavLink onClick={() => zones.open("manage")}>Music zones</NavLink>
                          </DropdownItem>
                        )}
                        {/* Stripe billing page: on the web app (phone and laptop), not in the store apps (no store fees) */}
                        {isSubscribed && !isApp() && !zones.playOnly && (
                          <DropdownItem className="dropdown__item">
                            <NavLink href={config.STRIPE_PORTAL} target="_blank" rel="noopener noreferrer">Manage billing</NavLink>
                          </DropdownItem>
                        )}
                        <DropdownItem className="dropdown__item">
                          <NavLink onClick={this.logout}>
                            Logout{` `}
                            <Logout />
                          </NavLink>
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem className="dropdown__item dropdown__item--danger">
                          <NavLink onClick={deleteAccount}>Delete my account</NavLink>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </NavItem>
                </Desktop>
              )}
              {isAuthenticated && (
                <MobileAndTablet>
                  {zones.enabled && !zones.playOnly && (
                    <NavItem className="header__section">
                      <NavLink onClick={() => { this.setState({ isOpen: false }); zones.open("manage"); }}>
                        Music zones
                      </NavLink>
                    </NavItem>
                  )}
                  {isSubscribed && !isApp() && !zones.playOnly && (
                    <NavItem className="header__section">
                      <NavLink href={config.STRIPE_PORTAL} target="_blank" rel="noopener noreferrer">Manage billing</NavLink>
                    </NavItem>
                  )}
                  <AddToHomeScreen wrapperClassName="header__section" />
                  <NavItem className="header__section">
                    <NavLink onClick={this.logout}>
                      Logout <Logout />
                    </NavLink>
                  </NavItem>
                  <NavItem className="header__section header__delete-account">
                    <NavLink onClick={deleteAccount}>Delete my account</NavLink>
                  </NavItem>
                  {appVersion() && (
                    <NavItem className="header__section header__app-version">
                      GymRadio app version {appVersion()}
                    </NavItem>
                  )}
                </MobileAndTablet>
              )}
              {!isAuthenticated && (
                <NavItem className="header__section">
                  <NavLink onClick={this.login}>Login</NavLink>
                </NavItem>
              )}
              {!isAuthenticated && (
                <NavItem className="header__section">
                  <NavLink onClick={this.signUp}>Sign up</NavLink>
                </NavItem>
              )}
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default inject((stores) => ({
  userStore: stores.userStore,
}))(observer(Header));
